import { render, staticRenderFns } from "./MFormTextMarkdown.vue?vue&type=template&id=2588af35&"
import script from "./MFormTextMarkdown.vue?vue&type=script&lang=js&"
export * from "./MFormTextMarkdown.vue?vue&type=script&lang=js&"
import style0 from "./MFormTextMarkdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports